module.exports = __webpack_public_path__ + "img/knight4_03.c9eacaad.jpg";